"use strict";

function getValueOfKeyMatching(params, reg) {
  var key = Object.keys(params || {}).filter(function (k) {
    return !!k.match(reg);
  });

  if (key && key.length > 0) {
    key = key[0];
  }

  return params && params[key] || '';
}

module.exports = getValueOfKeyMatching;